import {
  ErrorHandler,
  inject,
  Injectable,
  Injector,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BackgroundTaskService {

  private readonly injector: Injector = inject(Injector);

  /**
   * Method: Run a task without waiting for it and report its rejection to the global error handler
   * @param task - Promise whose result the caller deliberately does not wait for
   */
  public runInBackground(task: Promise<unknown>): void {
    task.catch(error => this.injector.get(ErrorHandler).handleError(error));
  }

}
